/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { DialogType, IDialogConfiguration } from 'apmui/components/dialog/Model';
import { IClientConfiguration } from 'apmui/plugin/Model';

type NADialogType =
    | DialogType.APPTUN_AUTO_START_NOT_SUPPORTED
    | DialogType.APPTUN_FAILED_TO_START
    | DialogType.APPTUN_INSTALL
    | DialogType.APPTUN_POPUP_BLOCKED
    | DialogType.NA_AUTO_START_NOT_SUPPORTED
    | DialogType.NA_FAILED_TO_START
    | DialogType.NA_INSTALL
    | DialogType.NA_POPUP_BLOCKED;

interface INetworkAccessModel {
    components: IClientConfiguration;
    dialogs: Record<NADialogType, IDialogConfiguration>;
}

export { INetworkAccessModel as default };
